;(function() {
  'use strict'

  AuthDialogController.$inject = ["$scope", "userService", "configService", "glAnalytics", "websiteService"];
  angular
    .module('core.auth')
    .controller('AuthDialogController', AuthDialogController)

  // --------------------

  /* @ngInject */
  function AuthDialogController(
    $scope,
    userService,
    configService,
    glAnalytics,
    websiteService
  ) {
    $scope.user = {}
    $scope.data = {}

    $scope.login = login
    $scope.signup = signup
    $scope.showSignup = showSignup
    $scope.showLogin = showLogin
    $scope.showForgot = showForgot
    $scope.reset = reset
    $scope.usernameChecker = userService.getUsernameChecker()

    $scope.success = $scope.success || angular.noop

    init()

    function init() {
      $scope.data.state = $scope.state || null
      $scope.user.email = $scope.prefillEmail || userService.getLastEmail()
      $scope.termsUrl = websiteService.getTermsUrl()
    }

    function login() {
      $scope.data.sending = true
      userService.login($scope.user).then(
        function() {
          glAnalytics.track('AuthDialog', 'login', $scope.user.email)
          $scope.dialog.close()
          $scope.success()
        },
        function() {
          $scope.data.sending = false
          $scope.data.error =
            'Please check your email and password and try again.'
        }
      )
    }

    function signup() {
      $scope.data.sending = true
      userService.signup($scope.user).then(
        function() {
          glAnalytics.track('AuthDialog', 'signup', $scope.user.email)
          $scope.dialog.close()
          $scope.success()
        },
        function(err) {
          $scope.data.sending = false
          $scope.data.error = err
        }
      )
    }

    function reset() {
      $scope.user.requesterDomain = configService
        .getUserPortalUrl()
        .split('://')[1]
      $scope.data.sending = true
      userService.reset($scope.user).then(
        function() {
          glAnalytics.track('AuthDialog', 'password-reset', $scope.user.email)
          $scope.data.sending = false
          $scope.data.state = 'forgotSuccess'
        },
        function() {
          $scope.data.sending = false
          $scope.data.error =
            'There was an issue resetting your password. Please try again.'
        }
      )
    }

    function showSignup() {
      $scope.data.state = 'signup'
      $scope.data.error = null
    }

    function showLogin() {
      $scope.data.state = 'login'
      $scope.data.error = null
    }

    function showForgot() {
      $scope.data.state = 'forgot'
      $scope.data.error = null
    }
  }
})()
